module.exports = {
    model: {
        document: null
    },

    methods: {
        prepare: function(storage, isServer){
            this.model.document = (((storage.request || {}).documentData || {}).meta || {}).document || {}
        }
    }
}